import { render, staticRenderFns } from "./PreCopyrightNavigation.vue?vue&type=template&id=5029533d&scoped=true&"
import script from "./PreCopyrightNavigation.vue?vue&type=script&lang=js&"
export * from "./PreCopyrightNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PreCopyrightNavigation.vue?vue&type=style&index=0&id=5029533d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5029533d",
  null
  
)

export default component.exports